var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMarkCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.51 12.78v.81h-1.5v-2.05c.17.05.4.08.7.08.87 0 1.37-.42 1.37-1.1 0-.65-.44-1.02-1.15-1.02-.65 0-1.07.32-1.15.86H9.24c.1-1.4 1.15-2.22 2.74-2.22 1.7 0 2.7.94 2.7 2.39 0 .59-.2 1.1-.6 1.5-.4.42-.91.67-1.57.75zM12.57 14.26v1.53h-1.62v-1.53h1.62z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 1020 0 10 10 0 00-20 0zm1.88 0a8.12 8.12 0 1116.24 0 8.12 8.12 0 01-16.24 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question-mark-circle.05690bfe92a5aae2bec908d1783ef47f.svg";